/** Offline Attribute Modal */

// These attributes are being filtered out of backend response as defined in https://sharethis.atlassian.net/wiki/spaces/PT/pages/2359033879
export const REMOVED_ATTRIBUTES = ['b2b', 'cpg', 'ls', 'pschographicB2b', 'type', 'default']
export const offlineAttributesModal = {
  attributeName: {
    // B2B: 'b2b',
    // CPG: 'cpg',
    // LS: 'ls',
    NETWISE: 'netwise',
    WORKSIN: 'worksin',
  },
  EMPTY_STRING: '',
  SAVE_CHANGES_SUCCESS_MESSAGE: 'Topics updated',
  OFFLINE_TOPICS_HEADER: 'Select Prebuilt Topics',
  SAVE_CHANGES: 'Confirm',
  NO_SEARCH_DATA_MESSAGE: `We couldn't find the attribute you're looking for. Please try again.`,
}

// prettier-ignore
export const PSYCHOGRAPHICS_ATTRIBUTES = [
  'auto_hybrid', 'auto_race', 'automotive', 'bargain_hunter', 'beauty', 'beauty_hair_care', 'beauty_spa', 'boating', 'book_reading', 'camping', 'climate_change', 'coffee_tea', 'computer_programming', 'consumer_electronics', 'cooking', 'diet', 'dine_out', 'education', 'fashion', 'finance', 'financial_borrowing', 'financial_management', 'financial_market', 'fitness', 'gardening', 'graduate', 'green_living', 'higher_education', 'home_furnishing', 'home_improvement', 'insurance', 'investing', 'job_search', 'learning_language', 'mover', 'movie', 'music', 'newly_wed', 'news', 'news_business', 'news_celebrity', 'news_politics', 'news_weather', 'online_banking', 'online_shopping', 'online_video', 'outdoor', 'performing_arts', 'pets', 'political_conservative', 'political_liberal', 'real_estate', 'reference', 'science', 'social_advocacy', 'social_network', 'spirituality', 'sports', 'sports_american_football', 'sports_baseball', 'sports_basketball', 'sports_combat', 'sports_cycling', 'sports_golf', 'sports_hockey', 'sports_soccer', 'sports_tennis', 'tech_savvy', 'travel', 'travel_air', 'travel_beaches_islands', 'travel_cruise', 'travel_hotel', 'travel_lakes_river', 'video_games', 'water_activity', 'water_sports', 'winter_sports',
]
/** /Offline Attribute Modal */
